import React, { useState, useEffect } from "react";
import useStyles from "../style";
import useStylesTable from "../../settings/styles";
import useStylesTravelerSwitch from "../../user/styles";
import { useLocation, useHistory } from "react-router-dom";
import config from "../../../config";
import axios from "axios";

// components
import InputComponent from "./inputComponent";
import InputSelect from "./inputSelect";
import PageTitle from "../../../components/PageTitle/PageTitle";
import InputDisableAge from "../../user/components/inputDisableAge";
import InputDisableSimpleText from "../../user/components/inputDisableSimpleText";
import { Edit, Delete, RefreshRounded } from "@material-ui/icons";
import Modal from "../../modals/Modal";
import ModalGroupType from "../../modals/ModalGroupType";
import ModalMembershipType from "../../modals/ModalMembershipType";
import ModalDeleteItem from "../../modals/ModalDeleteItem";
import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
import MenuItem from '@material-ui/core/MenuItem';
import Checkbox from "@material-ui/core/Checkbox";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import {
    Table,
    TableRow,
    TableHead,
    TableBody,
    TableCell, CircularProgress, Switch, TextField, Grid
} from "@material-ui/core";
import SimpleImageInput from "../../user/components/simpleImageInput";
import Autocomplete from '@material-ui/lab/Autocomplete';
import LogsTable from "./LogsTable";
import SnackbarMessage from "../../modals/SnackbarMessage";

export default function PartnerInfo() {
    const expressions = {
        usuario: /^[a-zA-Z0-9_-]{4,16}$/, // Letras, numeros, guion y guion_bajo
        nombre: /^[a-zA-ZÀ-ÿ\s]{1,40}$/, // Letras y espacios, pueden llevar acentos.
        password: /^.{4,12}$/, // 4 a 12 digitos.
        email: /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/,
        numbers: /^[0-9]*$/, // 7 a 14 numeros.
        texto: /^[a-zA-Z0-9 ]{4,500}$/, // Letras
    }

    const classes = useStyles();
    const classesTable = useStylesTable();
    const classesTravelerSwitch = useStylesTravelerSwitch();
    const location = useLocation();
    const history = useHistory();

    const [baseUrl, setBaseUrl] = useState(config.config[0].baseUrl);
    const [idToken, setIdToken] = useState(localStorage.getItem("id_token"));
    const [name, setName] = useState({ text: '', valid: null });
    const [lastName, setLastName] = useState({ text: '', valid: null });
    const [birthdayDate, setBirthdayDate] = useState('');
    const [birthdayValue, setBirthdayValue] = useState('');
    const [age, setAge] = useState('Edad');
    const [address, setAddress] = useState({ text: '', valid: null });
    const [phone, setPhone] = useState({ text: '', valid: null });
    const [email, setEmail] = useState({ text: '', valid: null });
    const [gender, setGender] = useState({ text: '', valid: null });
    const [membershipType, setMembershipType] = useState({ text: '', membershipValidity: 0, services: [], valid: null });
    const [partnerType, setPartnerType] = useState({ text: '', valid: null });
    const [partnerStatus, setPartnerStatus] = useState({ text: '', valid: null });
    const [creationDate, setCreationDate] = useState('');
    const [lastUpdateDate, setLastUpdateDate] = useState('');
    const [membershipStartDate, setMembershipStartDate] = useState('');
    const [membershipStartDateValue, setMembershipStartDateValue] = useState('');
    const [dueDate, setDueDate] = useState('');
    const [lastAccessDate, setLastAccessDate] = useState('');
    const [accessCount, setAccessCount] = useState('');
    const [accessCountMembership, setAccessCountMembership] = useState('');
    const [paidInscription, setPaidInscription] = useState(false);
    const [isTraveler, setIsTraveler] = useState(false);
    const [isTravelerValue, setIsTravelerValue] = useState(false);
    const [image, setImage] = useState(null);
    const [principalImage, setPrincipalImage] = useState(null);
    const [fingerPrint, setFingerPrint] = useState({ text: '', valid: null });
    const [autocompleteKey, setAutocompleteKey] = useState(0);
    const [groupType, setGroupType] = useState({ text: '', numberOfPersons: 0, discount: 0, valid: null, isDiscountByPercent: false });
    const [partnerId, setPartnerId] = useState(0);

    const [partnerInfo, setPartnerInfo] = useState([]);
    const [allGenders, setAllGenders] = useState([]);
    const [allDays, setAllDays] = useState([]);
    const [allMembershipType, setAllMembershipType] = useState([]);
    const [allPartnerType, setAllPartnerType] = useState([]);
    const [allStatus, setAllStatus] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [isLoadingToSaveUser, setIsLoadingToSaveUser] = useState(false);
    const [disableInpunts, setDisableInpunts] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [showModalGroupType, setShowModalGroupType] = useState(false);
    const [showModalMemershipType, setShowModalMembershipType] = useState(false);
    const [showModalDeleteItem, setShowModalDeleteItem] = useState(false);
    const [allFingerPrints, setAllFingerPrints] = useState([]);
    const [allGroupType, setAllGroupType] = useState([]);
    const [newGroup, setNewGroup] = useState("");
    const [minOfPersons, setMinOfPersons] = useState(0);
    const [isPendding, setIsPendding] = useState(false);
    const [newMembership, setNewMembership] = useState("");
    const [membershipId, setMembershipId] = useState(0);
    const [oldCost, setOldCost] = useState(0);
    const [newCost, setNewCost] = useState(0);
    const [differrence, setDifferrence] = useState(0);

    const [filteredData, setFilteredData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [filteredEntryData, setFilteredEntryData] = useState([]);
    const [currentEntryPage, setCurrentEntryPage] = useState(1);
    const [totalEntryPages, setTotalEntryPages] = useState(1);

    const [showSnackbar, setShowSnackbar] = useState(false);
    const [messageSnackbar, setMessageSnackbar] = useState(false);
    const [errorSnackbar, setErrorSnackbar] = useState(false);

    const ITEM_HEIGHT = 48;
    const ITEM_PADDING_TOP = 8;
    const MenuProps = {
        PaperProps: {
            style: {
                maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                width: 250
            }
        },
        getContentAnchorEl: null,
        anchorOrigin: {
            vertical: "bottom",
            horizontal: "center"
        },
        transformOrigin: {
            vertical: "top",
            horizontal: "center"
        },
        variant: "menu"
    };

    const closeModalLogin = e => {
        setShowModal(false);
    }

    const closeModalGroupType = e => {
        setShowModalGroupType(false);
    }

    const closeModalMembershipType = e => {
        setShowModalMembershipType(false);
    }

    const closeModalDeleteItem = e => {
        setShowModalDeleteItem(false);
    }

    function getLabel(value) {
        if (value == null || value == '') {
            return '';
        }

        var day = value.toString().substring(8);
        var month = value.toString().substring(5, 7);
        var year = value.toString().substring(0, 4);

        return year + '-' + month + '-' + day;
    }

    function getValue(value) {
        var year = value.substring(6);
        var month = value.substring(3, 5);
        var day = value.substring(0, 2);

        return year + "-" + month + "-" + day;
    }

    const fetchPartnerInfo = async () => {
        var id = '';

        try {
            if (location.state.id == null) {
                id = location.state.id;
            } else {
                id = localStorage.getItem('partnerInfo');
            }
        } catch (e) {
            id = localStorage.getItem('partnerInfo');
        }

        setPartnerId(id);

        fetch(baseUrl + "partnerById/" + id,
            {
                headers: {
                    'Accept': 'application/json', 'Content-Type': 'application/json',
                    'Authorization': localStorage.getItem("token")
                },
            })
            .then(response => response.json())
            .then(data => {
                if (data != null) {
                    setPartnerInfo(data);
                    setName({ text: data.name, valid: 'true' });
                    setLastName({ text: data.lastName, valid: 'true' });
                    setBirthdayDate(data.birthdayDate);
                    setBirthdayValue(getLabel(data.birthdayDate));
                    setAge(data.age);
                    setAddress({ text: data.address, valid: 'true' });
                    setPhone({ text: data.phone, valid: 'true' });
                    setEmail({ text: data.email, valid: 'true' });
                    setGender({ text: data.gender, valid: 'true' });

                    const servicesList = [];
                    data.dayOfServices.map((option) => {
                        var daysList = [];

                        for (var i = 0; i < option.days.length; i++) {
                            if (option.days[i] != "") {
                                var day = option.days[i].replace('\"', "").replace('"', "");
                                daysList.push(day);
                            }
                        }

                        var servicesItem = {
                            "serviceName": option.serviceName,
                            "numberOfDays": option.numberOfDays,
                            "days": daysList,
                            "isAllSelected": daysList.length === 7 ? true : false
                        };

                        servicesList.push(servicesItem);
                    });

                    setImage(data.image);
                    setMembershipType({ text: data.membershipType, membershipValidity: 0, services: servicesList, valid: 'true' });
                    setPartnerType({ text: data.partnerType, valid: 'true' });
                    setPartnerStatus({ text: data.partnerStatus, valid: 'true' });
                    setMembershipStartDate(data.membershipStartDate);
                    setMembershipStartDateValue(getValue(data.membershipStartDate));
                    setCreationDate(data.creationDate);
                    setLastUpdateDate(data.lastUpdateDate);
                    setDueDate(data.dueDate);
                    setLastAccessDate(data.lastAccessDate);
                    setPaidInscription(data.paidInscription == 0 ? false : true);
                    setIsTraveler(data.isTraveler == 0 ? false : true);
                    setIsTravelerValue(data.isTraveler == 0 ? false : true);
                    setAccessCount(data.accessCount);
                    setAccessCountMembership(data.accessCountMembership);
                    setGroupType({ ...groupType, text: data.groupType });
                } else {
                    setShowModal(true);
                }

                setIsLoading(false);
            })
            .catch(error => null);
    }

    const fetchFingerPrints = async () => {
        if (!showModal) {
            fetch(baseUrl + "getTemplates",
                {
                    headers: {
                        'Accept': 'application/json', 'Content-Type': 'application/json',
                        'Authorization': localStorage.getItem("token")
                    },
                }).then(response => response.json())
                .then(data => {
                    if (data.error != null) {
                        setShowModal(true);
                    } else {
                        setAllFingerPrints(data);
                    }
                })
                .catch(error => null);
        }
    }

    const fetchGenders = async () => {
        if (!showModal) {
            fetch(baseUrl + "genders",
                {
                    headers: {
                        'Accept': 'application/json', 'Content-Type': 'application/json',
                        'Authorization': localStorage.getItem("token")
                    },
                }).then(response => response.json())
                .then(data => {
                    if (data != null) {
                        setAllGenders(data);
                    } else {
                        setShowModal(true);
                    }
                }).catch(error => null);
        }
    }

    const fetchMembershipType = async () => {
        if (!showModal) {
            fetch(baseUrl + "membershipAndService",
                {
                    headers: {
                        'Accept': 'application/json', 'Content-Type': 'application/json',
                        'Authorization': localStorage.getItem("token")
                    },
                }).then(response => response.json())
                .then(data => {
                    if (data != null) {
                        setAllMembershipType(data);
                    } else {
                        setShowModal(true);
                    }
                }).catch(error => null);
        }
    }

    const fetchPartnerType = async () => {
        if (!showModal) {
            fetch(baseUrl + "partnerType",
                {
                    headers: {
                        'Accept': 'application/json', 'Content-Type': 'application/json',
                        'Authorization': localStorage.getItem("token")
                    },
                }).then(response => response.json())
                .then(data => {
                    if (data != null) {
                        setAllPartnerType(data);
                    } else {
                        setShowModal(true);
                    }
                }).catch(error => null);
        }
    }

    const fetchStatus = async () => {
        if (!showModal) {
            fetch(baseUrl + "genericStatus",
                {
                    headers: {
                        'Accept': 'application/json', 'Content-Type': 'application/json',
                        'Authorization': localStorage.getItem("token")
                    },
                }).then(response => response.json())
                .then(data => {
                    if (data != null) {
                        setAllStatus(data);
                    } else {
                        setShowModal(true);
                    }
                }).catch(error => null);
        }
    }

    const fetchDays = async () => {
        if (!showModal) {
            fetch(baseUrl + "days",
                {
                    headers: {
                        'Accept': 'application/json', 'Content-Type': 'application/json',
                        'Authorization': localStorage.getItem("token")
                    },
                }).then(response => response.json())
                .then(data => {
                    if (data.error == null) {
                        setAllDays(data);
                    } else {
                        setShowModal(true);
                    }
                }).catch(error => null);
        }
    }

    const fetchGroupType = async () => {
        if (!showModal) {
            fetch(baseUrl + "groupTypePartner",
                {
                    headers: {
                        'Accept': 'application/json', 'Content-Type': 'application/json',
                        'Authorization': localStorage.getItem("token")
                    },
                }).then(response => response.json())
                .then(data => {
                    if (data.error == null) {
                        var list = [];
                        list.push(
                            {
                                "name": "Individual",
                                "numberOfPersons": 1,
                                "discount": 0.0,
                                "isDiscountByPercent": 0,
                            },
                        );
                        data.map((item) => {
                            list.push(item);
                        });
                        setAllGroupType(list);
                    } else {
                        setShowModal(true);
                    }
                }).catch(error => null);
        }
    }

    useEffect(() => {
        fetchPartnerInfo();
        fetchFingerPrints();
        fetchGenders();
        fetchMembershipType();
        fetchPartnerType();
        fetchStatus();
        fetchDays();
        fetchGroupType();
        fetchPartnerPaymentLogs();
        fetchPartnerEntryLogs();
    }, [location]);

    const onChangeDatePicker = (e) => {
        setBirthdayDate(e.target.value);

        var today = new Date();
        var birthDate = new Date(e.target.value);
        var age = today.getFullYear() - birthDate.getFullYear();
        var m = today.getMonth() - birthDate.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }
        setAge(age);
    }

    const handleChangeTraveler = event => {
        var value = event.target.checked;

        setIsTraveler(value);
    };

    const onSubmit = async e => {
        e.preventDefault();
        setIsLoadingToSaveUser(true);

        var allList = "[";
        if (membershipType.services.length > 1) {

            for (var i = 0; i < membershipType.services.length; i++) {
                var item = membershipType.services[i];
                if (i == (membershipType.services.length - 1)) {
                    allList = allList + "{serviceName: " + item.serviceName + ", numberOfDays: " + item.numberOfDays + ", days: [" + item.days + "]}]";
                } else {
                    allList = allList + "{serviceName: " + item.serviceName + ", numberOfDays: " + item.numberOfDays + ", days: [" + item.days + "]}, ";
                }
            }
        } else {
            var item = membershipType.services[0];
            allList = "[{serviceName: " + item.serviceName + ", numberOfDays: " + item.numberOfDays + ", days: [" + item.days + "]}]";
        }
        const formData = new FormData();
        if (principalImage != null) formData.append("file", principalImage);
        formData.append("partnerId", partnerInfo.id);
        formData.append("name", name.text);
        formData.append("lastName", lastName.text);
        formData.append("birthdayDate", birthdayDate);
        formData.append("age", age == 'Edad' ? 0 : age);
        formData.append("address", address.text);
        formData.append("email", email.text);
        formData.append("phone", phone.text);
        formData.append("gender", gender.text);
        formData.append("membershipType", membershipType.text);
        formData.append("partnerType", partnerType.text);
        formData.append("partnerStatus", partnerStatus.text);
        formData.append("membershipStartDate", membershipStartDate);
        formData.append("dayOfServices", allList);
        formData.append("isTraveler", isTraveler ? 1 : 0);
        if (fingerPrint.text != null && fingerPrint.text != '') formData.append("fingerPrint", fingerPrint.text);

        await axios({
            method: "put",
            url: baseUrl + "updatePartner",
            data: formData,
            headers: { "Content-Type": "multipart/form-data", 'Authorization': localStorage.getItem("token") },
        })
            .then(function (response) {
                if (response.data.message == "Ok") {

                } else {
                    if (response.data.message == "Access is denied") {
                        setShowModal(true);
                    }
                }
            })
            .catch(function (response) { });

        setDisableInpunts(!disableInpunts);
        setFingerPrint({ text: '', valid: null });
        setAutocompleteKey(autocompleteKey + 1);
        setIsLoadingToSaveUser(false);

        fetchPartnerInfo();
    }

    const onDelete = async e => {
        setIsLoadingToSaveUser(true);

        const response = await fetch(baseUrl + "deletePartner/" + partnerInfo.id, {
            method: 'DELETE',
            headers: {
                'Accept': 'application/json', 'Content-Type': 'application/json',
                'Authorization': localStorage.getItem("token")
            },
        });

        const json = await response.json();
        if (json.message == "Ok") {
            localStorage.setItem('partnerInfo', '');
            history.goBack();
        } else {
            if (json.message == "Access is denied") {
                setShowModal(true);
            }
        }
        setDisableInpunts(!disableInpunts);
        setIsLoadingToSaveUser(false);
    }

    const handleChangeDays = (property) => (e) => {
        const value = e.target.value;
        var serviceLessSevenDays = false;

        membershipType.services.map((item) => {
            if (item.serviceName == property) {
                if (item.numberOfDays < 7) {
                    serviceLessSevenDays = true;
                }
            }
        });

        if (!serviceLessSevenDays) {
            if (value[value.length - 1] === "all") {
                const allDaysList = [];

                allDays.map((option) => {
                    allDaysList.push(option.name);
                });

                membershipType.services.map((item) => {

                    if (item.serviceName == property) {
                        var index = membershipType.services.indexOf(item);

                        var servicesItem = {
                            "serviceName": item.serviceName,
                            "numberOfDays": item.numberOfDays,
                            "days": item.days.length === allDays.length ? [] : allDaysList,
                            "isAllSelected": item.days.length === allDays.length ? false : true
                        };

                        const allList = membershipType.services;
                        allList[index] = servicesItem;
                        setMembershipType({ ...membershipType, services: allList });
                    }
                });
                return;
            }
            if (value != '') {
                membershipType.services.map((item) => {
                    if (item.serviceName == property) {
                        const isAllSelected = allDays.length > 0 && item.days.length === allDays.length;
                        var index = membershipType.services.indexOf(item);

                        var servicesItem = {
                            "serviceName": item.serviceName,
                            "numberOfDays": item.numberOfDays,
                            "days": value,
                            "isAllSelected": isAllSelected
                        };

                        const allList = membershipType.services;
                        allList[index] = servicesItem;
                        setMembershipType({ ...membershipType, services: allList });
                    }
                });
                return;
            }

            membershipType.services.map((item) => {
                if (item.serviceName == property) {
                    const isAllSelected = allDays.length > 0 && item.days.length === allDays.length;
                    var index = membershipType.services.indexOf(item);

                    var servicesItem = {
                        "serviceName": item.serviceName,
                        "numberOfDays": item.numberOfDays,
                        "days": value,
                        "isAllSelected": isAllSelected
                    };

                    const allList = membershipType.services;
                    allList[index] = servicesItem;
                    setMembershipType({ ...membershipType, services: allList });
                }
            });
        } else {
            if (value[value.length - 1] === "all") {
                return;
            }
            if (value != '') {
                membershipType.services.map((item) => {
                    if (item.serviceName == property) {
                        const isAllSelected = allDays.length > 0 && item.days.length === allDays.length;
                        var index = membershipType.services.indexOf(item);

                        var servicesItem = {
                            "serviceName": item.serviceName,
                            "numberOfDays": item.numberOfDays,
                            "days": value,
                            "isAllSelected": isAllSelected
                        };

                        if (value.length <= item.numberOfDays) {
                            const allList = membershipType.services;
                            allList[index] = servicesItem;
                            setMembershipType({ ...membershipType, services: allList });
                        }
                    }
                });
                return;
            }

            membershipType.services.map((item) => {
                if (item.serviceName == property) {
                    const isAllSelected = allDays.length > 0 && item.days.length === allDays.length;
                    var index = membershipType.services.indexOf(item);

                    var servicesItem = {
                        "serviceName": item.serviceName,
                        "numberOfDays": item.numberOfDays,
                        "days": value,
                        "isAllSelected": isAllSelected
                    };

                    if (value.length <= item.numberOfDays) {
                        const allList = membershipType.services;
                        allList[index] = servicesItem;
                        setMembershipType({ ...membershipType, services: allList });
                    }
                }
            });
        }
    }

    const onChangeDatePickerStart = (e) => {
        setMembershipStartDate(e.target.value);
    }

    const onTagsChange = (event, values) => {
        if (values != null) {
            setFingerPrint({ text: values.template, valid: "true" });
        } else {
            setFingerPrint({ text: '', valid: "false" });
        }
    }

    const fetchPartnerPaymentLogs = async () => {
        const body = {
            partnerId: localStorage.getItem('partnerInfo'), page: 0
        };

        fetch(baseUrl + "partnerLogs/payments",
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json', 'Content-Type': 'application/json',
                    'Authorization': localStorage.getItem("token")
                },
                body: JSON.stringify(body)
            }).then(response => response.json())
            .then(data => {
                const newData = data.content;

                if (newData != null) {
                    setFilteredData(newData);
                    setTotalPages(data.totalPages);
                } else {
                    setTotalPages(0);
                    setCurrentPage(0);
                }
            })
            .catch(error => null);
    }

    const onNextPage = e => {
        if (currentPage < totalPages) {
            const body = {
                partnerId: localStorage.getItem('partnerInfo'), page: currentPage
            };

            fetch(baseUrl + "partnerLogs/payments",
                {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json', 'Content-Type': 'application/json',
                        'Authorization': localStorage.getItem("token")
                    },
                    body: JSON.stringify(body)
                }).then(response => response.json())
                .then(data => {
                    const newData = data.content;

                    if (newData != null) {
                        setFilteredData(newData);
                        setTotalPages(data.totalPages);
                        setCurrentPage(data.number + 1);
                    }
                })
                .catch(error => null);
        }
    }

    const onPreviousPage = e => {
        if (currentPage > 1) {
            const body = {
                partnerId: localStorage.getItem('partnerInfo'), page: currentPage - 2
            };

            fetch(baseUrl + "partnerLogs/payments",
                {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json', 'Content-Type': 'application/json',
                        'Authorization': localStorage.getItem("token")
                    },
                    body: JSON.stringify(body)
                }).then(response => response.json())
                .then(data => {
                    const newData = data.content;

                    if (newData != null) {
                        setFilteredData(newData);
                        setTotalPages(data.totalPages);
                        setCurrentPage(data.number + 1);
                    }
                })
                .catch(error => null);
        }
    }

    const fetchPartnerEntryLogs = async () => {
        const body = {
            partnerId: localStorage.getItem('partnerInfo'), page: 0
        };

        fetch(baseUrl + "partnerLogs/entry",
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json', 'Content-Type': 'application/json',
                    'Authorization': localStorage.getItem("token")
                },
                body: JSON.stringify(body)
            }).then(response => response.json())
            .then(data => {
                const newData = data.content;

                if (newData != null) {
                    setFilteredEntryData(newData);
                    setTotalEntryPages(data.totalPages);
                } else {
                    setTotalEntryPages(0);
                    setCurrentEntryPage(0);
                }
            })
            .catch(error => null);
    }

    const onNextEntryPage = e => {
        if (currentEntryPage < totalEntryPages) {
            const body = {
                partnerId: localStorage.getItem('partnerInfo'), page: currentEntryPage
            };

            fetch(baseUrl + "partnerLogs/entry",
                {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json', 'Content-Type': 'application/json',
                        'Authorization': localStorage.getItem("token")
                    },
                    body: JSON.stringify(body)
                }).then(response => response.json())
                .then(data => {
                    const newData = data.content;

                    if (newData != null) {
                        setFilteredEntryData(newData);
                        setTotalEntryPages(data.totalPages);
                        setCurrentEntryPage(data.number + 1);
                    }
                })
                .catch(error => null);
        }
    }

    const onPreviousEntryPage = e => {
        if (currentEntryPage > 1) {
            const body = {
                partnerId: localStorage.getItem('partnerInfo'), page: currentEntryPage - 2
            };

            fetch(baseUrl + "partnerLogs/entry",
                {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json', 'Content-Type': 'application/json',
                        'Authorization': localStorage.getItem("token")
                    },
                    body: JSON.stringify(body)
                }).then(response => response.json())
                .then(data => {
                    const newData = data.content;

                    if (newData != null) {
                        setFilteredEntryData(newData);
                        setTotalEntryPages(data.totalPages);
                        setCurrentEntryPage(data.number + 1);
                    }
                })
                .catch(error => null);
        }
    }

    const handleChangeGroup = (e) => {
        const value = e.target.value;
        if (value != '') {
            var numberOfPersons = 0;

            allGroupType.map((option) => {
                if (option.name == value) {
                    numberOfPersons = option.numberOfPersons;
                }
            });

            if (value != partnerInfo.groupType) {
                setNewGroup(value);
                setShowModalGroupType(true);
                setMinOfPersons(numberOfPersons);
            }
        }
    }

    const onFinishGroupType = () => {
        fetchPartnerInfo();
    };

    const handleChangeMembershipType = (e) => {
        const value = e.target.value;

        if (value != '') {
            var membershipValidity = '';
            var currentMembershipValidity = '';
            var cost = 0;
            var newCost = 0;
            var membershipId = 0;

            for (var i = 0; i < allMembershipType.length; i++) {
                var item = allMembershipType[i];

                if (item.membershipName == value) {
                    membershipValidity = item.membershipValidity;
                    newCost = item.cost;
                    membershipId = item.membershipId;

                    i = allMembershipType.length;
                }
            }

            for (var i = 0; i < allMembershipType.length; i++) {
                var item = allMembershipType[i];

                if (item.membershipName == membershipType.text) {
                    cost = item.cost;
                    currentMembershipValidity = item.membershipValidity;

                    i = allMembershipType.length;
                }
            }

            setNewMembership(value);
            setMembershipId(membershipId);
            setOldCost(cost);
            setNewCost(newCost);

            var dif = Number(newCost) - Number(cost);

            if (dif <= 0) {
                setDifferrence(0)
                setIsPendding(false);
            } else {
                setDifferrence(dif);
                setIsPendding(true);
            }

            setShowModalMembershipType(true);
        }
    }

    const onFinishMembershipType = (value) => {
        if (value === "Ok") {
            setMessageSnackbar("Actualizado con éxito");
            setErrorSnackbar(false);
        } else {
            setMessageSnackbar("Error al actualizar");
            setErrorSnackbar(true);
        }

        setDisableInpunts(!disableInpunts);
        setShowSnackbar(true);
        fetchPartnerInfo();
    };

    const handleToClose = (event, reason) => {
        if ("clickaway" == reason) return;
        setShowSnackbar(false);
    };

    const onClickYesDelete = () => {
        onDelete();
    };

    return (
        <div>
            {showModal ? (
                <Modal
                    isOpen={showModal}
                    closeModal={closeModalLogin}
                />
            ) : (
                <></>
            )}

            {showModalGroupType ? (
                <ModalGroupType
                    isOpen={showModalGroupType}
                    closeModal={closeModalGroupType}
                    partnerId={partnerId}
                    origin={partnerInfo.groupType}
                    newGroup={newGroup}
                    minOfPersons={minOfPersons}
                    onFinish={onFinishGroupType}
                />
            ) : (
                <></>
            )}

            {showModalMemershipType ? (
                <ModalMembershipType
                    isOpen={showModalMemershipType}
                    closeModal={closeModalMembershipType}
                    partnerId={partnerId}
                    onFinish={onFinishMembershipType}
                    isPendding={isPendding}
                    origin={partnerInfo.membershipType}
                    newMembership={newMembership}
                    membershipId={membershipId}
                    oldCost={oldCost}
                    newCost={newCost}
                    differrence={differrence}
                    partnerStatus={partnerInfo.partnerStatus}
                />
            ) : (
                <></>
            )}

            {showModalDeleteItem ? (
                <ModalDeleteItem
                    isOpen={showModalDeleteItem}
                    closeModal={closeModalDeleteItem}
                    ClickYes={onClickYesDelete}
                    title={"Eliminar registro"}
                    subtitle={"El registro será eliminado permanentemente"}
                />
            ) : (
                <></>
            )}

            <SnackbarMessage
                showSnackbar={showSnackbar}
                messageSnackbar={messageSnackbar}
                handleToClose={handleToClose}
                isError={errorSnackbar}
            />

            <div className={classes.titleRow}>
                <PageTitle title="Información del socio" />

                {isLoading ? (
                    <></>
                ) : (
                    <>
                        <div className={classes.marginAuto} />
                        <div className={classes.divActionButton} >
                            <Edit classes={{ root: classes.searchIcon }}
                                onClick={() => {
                                    setDisableInpunts(!disableInpunts);
                                }}
                            />
                        </div>

                        {idToken == 1 ? (
                            <>
                                <div className={classes.divActionButtonDisable} >
                                    <Delete
                                        classes={{ root: !disableInpunts ? classes.activeButtonDisable : classes.searchIcon }}
                                        onClick={!disableInpunts ? null : () => {
                                            setShowModalDeleteItem(true);
                                        }}
                                    />
                                </div>
                            </>
                        ) : (
                            <></>
                        )}
                    </>
                )}
            </div>

            <div className={classes.divCard} >
                {isLoading ? (
                    <CircularProgress size={26} className={classes.loginPage} />
                ) : (
                    <>
                        <div className={classes.divColumn} >
                            <InputComponent
                                text={name}
                                setPartnerCode={setName}
                                type="text"
                                label="Nombres"
                                name="name"
                                regularExpression={expressions.nombre}
                                placeholder="Nombre"
                                isEnable={disableInpunts}
                            />

                            <InputComponent
                                text={lastName}
                                setPartnerCode={setLastName}
                                type="text"
                                label="Apellidos"
                                name="lastName"
                                regularExpression={expressions.nombre}
                                placeholder="Apellidos"
                                isEnable={disableInpunts}
                            />

                            <div className={classes.divDate}>
                                <label className={classes.labelDate} >Fecha de nacimiento</label>
                                <TextField
                                    type="date"
                                    defaultValue={birthdayValue}
                                    className={classes.inputDate}
                                    onChange={onChangeDatePicker}
                                    style={{ width: '85%' }}
                                    disabled={disableInpunts}
                                    inputStyle={{ width: '85%' }}
                                />
                            </div>

                            <InputDisableAge
                                value={age}
                                type="text"
                                label="Edad"
                                name="age"
                                placeholder="18 años"
                                isEnable={disableInpunts}
                            />

                            {!disableInpunts ? (
                                <SimpleImageInput
                                    text={principalImage}
                                    setValue={setPrincipalImage}
                                    label={"Foto del usuario"}
                                />
                            ) : (
                                <div style={{ width: "200px", height: "240px", marginBottom: "30px" }}>
                                    <p className={classes.label} >Foto del usuario</p>
                                    {image != null ? (
                                        <img
                                            src={baseUrl + "userImage/" + image}
                                            alt=""
                                            height={200}
                                            width={200}
                                        />
                                    ) : (
                                        <div style={{
                                            height: "200px", width: "200px", backgroundColor: "#021D61", borderRadius: "4px"
                                        }}>
                                        </div>
                                    )}
                                </div>
                            )}

                            <InputComponent
                                text={address}
                                setPartnerCode={setAddress}
                                type="text"
                                label="Dirección"
                                name="address"
                                regularExpression={expressions.texto}
                                placeholder="Calle primera, 1234, Centro"
                                isEnable={disableInpunts}
                            />

                            <InputComponent
                                text={phone}
                                setPartnerCode={setPhone}
                                type="text"
                                label="Teléfono"
                                name="phone"
                                regularExpression={expressions.numbers}
                                placeholder="6688888888"
                                isEnable={disableInpunts}
                            />

                            <InputComponent
                                text={email}
                                setPartnerCode={setEmail}
                                type="text"
                                label="Correo electrónico"
                                name="email"
                                regularExpression={expressions.email}
                                placeholder="correo@ejemplo.com"
                                isEnable={disableInpunts}
                            />

                            <InputSelect
                                text={gender}
                                setValue={setGender}
                                label={"Género"}
                                options={allGenders}
                                isEnable={disableInpunts}
                            />

                            <div className={classes.divHeader} >
                                <div className={classes.searchDivFullWidthWithoutShadow} >
                                    <Autocomplete
                                        key={autocompleteKey}
                                        options={allFingerPrints}
                                        getOptionLabel={option => option.code}
                                        onChange={onTagsChange}
                                        className={classes.inputSearchFinger}
                                        openText={"Abrir"}
                                        closeText={"Cerrar"}
                                        clearText={"Limpiar"}
                                        noOptionsText={"Sin resultados"}
                                        disabled={disableInpunts}
                                        renderInput={params => (
                                            <TextField
                                                {...params}
                                                variant="standard"
                                                placeholder={"Buscar huella digital"}
                                                fullWidth
                                            />
                                        )}
                                    />

                                    {disableInpunts ? (
                                        <></>
                                    ) : (
                                        <>
                                            <div className={classes.divActionButton}>
                                                <RefreshRounded className={classes.iconAcctionInventory}
                                                    onClick={fetchFingerPrints}
                                                />
                                            </div>
                                        </>
                                    )}
                                </div>
                            </div>

                            <div>
                                <div className={classes.divLabel}>
                                    <p className={classes.label} >Tipo de membresia</p>
                                </div>
                                <FormControl className={classes.formControlGroupType}>
                                    <Select
                                        onChange={handleChangeMembershipType}
                                        displayEmpty
                                        disabled={disableInpunts}
                                        value={membershipType.text}
                                        style={{ color: "#FFFFFF" }}
                                    >
                                        <MenuItem value=""> Selecciona </MenuItem>
                                        {allMembershipType.map((option) => (
                                            <MenuItem value={option.membershipName}>{option.membershipName}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </div>

                            <div>
                                <div className={classes.divLabel}>
                                    <p className={classes.label} >Grupo de membrecía</p>
                                </div>
                                <FormControl className={classes.formControlGroupType}>
                                    <Select
                                        onChange={handleChangeGroup}
                                        displayEmpty
                                        disabled={disableInpunts}
                                        value={groupType.text}
                                        style={{ color: "#FFFFFF" }}
                                    >
                                        <MenuItem value=""> Selecciona </MenuItem>
                                        {allGroupType.map((option) => (
                                            <MenuItem value={option.name}>{option.name}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </div>

                            <div>
                                <div className={classes.divLabel}>
                                    <p className={classes.label} >{"Días de acceso"}</p>
                                </div>

                                <div style={{ backgroundColor: "#FFFFFF", borderRadius: '4px', }}>
                                    <Table className="mb-0">
                                        <TableHead>
                                            <TableRow className={classesTable.tableServices} >
                                                <TableCell>SERVICIO</TableCell>
                                                <TableCell>DÍAS SEMANA</TableCell>
                                                <TableCell># DE DÍAS</TableCell>
                                                {/*{keys.map(key => (
                                                <TableCell key={key}>{key}</TableCell>
                                            ))}*/}
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {membershipType.services.map(({ serviceName, numberOfDays, days, isAllSelected }) => (
                                                <TableRow>
                                                    <TableCell className={classesTable.tableServicesTextStyle} >{serviceName}</TableCell>

                                                    <TableCell className={classesTable.tableServicesTextStyle} >
                                                        <FormControl className={classes.formControl}>
                                                            {numberOfDays == 7 ? (
                                                                <>
                                                                    <p style={{ color: "#000000" }}>L, M, M, J, V, S, D</p>
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <Select
                                                                        labelId="mutiple-select-label"
                                                                        multiple
                                                                        value={days}
                                                                        onChange={handleChangeDays(serviceName).bind(this)}
                                                                        renderValue={(selected) => selected.join(", ")}
                                                                        MenuProps={MenuProps}
                                                                        style={{ color: "#000000" }}
                                                                        disabled={disableInpunts}
                                                                    >
                                                                        <MenuItem
                                                                            value="all"
                                                                            classes={{
                                                                                root: isAllSelected ? classes.selectedAll : ""
                                                                            }}
                                                                        >
                                                                            <ListItemIcon>
                                                                                <Checkbox
                                                                                    classes={{ indeterminate: classes.indeterminateColor }}
                                                                                    checked={isAllSelected}
                                                                                    indeterminate={
                                                                                        days.length > 0 && days.length <= allDays.length
                                                                                    }
                                                                                />
                                                                            </ListItemIcon>
                                                                            <ListItemText
                                                                                classes={{ primary: classes.selectAllText }}
                                                                                primary="Seleccionar todos"
                                                                            />
                                                                        </MenuItem>
                                                                        {allDays.map((option) => (
                                                                            <MenuItem key={option.name} value={option.name}>
                                                                                <ListItemIcon>
                                                                                    <Checkbox checked={days.indexOf(option.name) > -1} />
                                                                                </ListItemIcon>
                                                                                <ListItemText primary={option.name} />
                                                                            </MenuItem>
                                                                        ))}
                                                                    </Select>
                                                                </>
                                                            )}
                                                        </FormControl>
                                                    </TableCell>

                                                    <TableCell className={classesTable.tableServicesTextStyle} >{numberOfDays + " días"}</TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </div>
                            </div>

                            <InputSelect
                                text={partnerType}
                                setValue={setPartnerType}
                                label={"Tipo de socio"}
                                options={allPartnerType}
                                isEnable={disableInpunts}
                            />

                            <InputDisableSimpleText
                                value={paidInscription ? "Pagado" : "Sin pagar"}
                                type="text"
                                label="Pago de inscripción"
                                name="paidInscription"
                                placeholder="Inscripción"
                                isPrice={false}
                            />

                            <InputDisableSimpleText
                                value={accessCountMembership}
                                type="text"
                                label="Accesos de membrecía"
                                name="accessCountMembership"
                                placeholder="1"
                                isPrice={false}
                            />

                            {!isTravelerValue ? (
                                <> </>
                            ) : (
                                <InputDisableSimpleText
                                    value={accessCount}
                                    type="text"
                                    label="Accesos restantes"
                                    name="accessCount"
                                    placeholder="1"
                                    isPrice={false}
                                />
                            )}

                            <div>
                                <label className={classesTravelerSwitch.label} >{"¿Usuario viajero?"}</label>
                                <div className={classesTravelerSwitch.divSwitch}>
                                    <p style={{ marginRight: "8px", fontSize: "16px", }}>No</p>
                                    <Switch
                                        checked={isTraveler}
                                        onChange={handleChangeTraveler}
                                        inputProps={{ "aria-label": "controlled" }}
                                        disabled={disableInpunts}
                                    />
                                    <p style={{ marginLeft: "8px", fontSize: "16px", }}>Si</p>
                                </div>
                            </div>

                            <InputSelect
                                text={partnerStatus}
                                setValue={setPartnerStatus}
                                label={"Estatus"}
                                options={allStatus}
                                isEnable={disableInpunts}
                            />

                            <InputDisableSimpleText
                                value={lastAccessDate}
                                type="text"
                                label="Fecha del último acceso"
                                name="lastAccessDate"
                                placeholder="Fecha"
                                isPrice={false}
                            />

                            <InputDisableSimpleText
                                value={creationDate}
                                type="text"
                                label="Fecha de alta"
                                name="creationDate"
                                placeholder="Fecha"
                                isPrice={false}
                            />

                            <InputDisableSimpleText
                                value={lastUpdateDate}
                                type="text"
                                label="Última modificación"
                                name="lastUpdateDate"
                                placeholder="Fecha"
                                isPrice={false}
                            />

                            <div className={classes.divDate}>
                                <label className={classes.labelDate} >Fecha de inicio de membrecía</label>
                                <TextField
                                    type="date"
                                    defaultValue={membershipStartDateValue}
                                    className={classes.inputDate}
                                    onChange={onChangeDatePickerStart}
                                    style={{ width: '85%' }}
                                    disabled={disableInpunts}
                                    inputStyle={{ width: '85%' }}
                                />
                            </div>

                            <InputDisableSimpleText
                                value={dueDate}
                                type="text"
                                label="Fecha de expiración de membrecía"
                                name="dueDate"
                                placeholder="Fecha"
                                isPrice={false}
                            />
                        </div>

                        <div className={classes.divColumn} >
                            <div style={{ justify: "center", alignItems: "center", margin: "auto" }} >
                                <text style={{ fontSize: "16px" }} >Historial de pagos</text>
                            </div>
                            <div style={{ justify: "center", alignItems: "center", margin: "auto" }} >
                                <text style={{ fontSize: "16px" }} >Historial de accesos</text>
                            </div>
                            <Grid item xs={12}>
                                <LogsTable
                                    data={filteredData}
                                    currentPage={currentPage}
                                    totalPages={totalPages}
                                    onPreviousPage={onPreviousPage}
                                    onNextPage={onNextPage}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <LogsTable
                                    data={filteredEntryData}
                                    currentPage={currentEntryPage}
                                    totalPages={totalEntryPages}
                                    onPreviousPage={onPreviousEntryPage}
                                    onNextPage={onNextEntryPage}
                                />
                            </Grid>
                        </div>
                    </>
                )}

                {disableInpunts ? (
                    <br />
                ) : (
                    <div className={classes.divButton}>
                        {isLoadingToSaveUser ? (
                            <div className={classes.loginLoader} >
                                <CircularProgress size={26} />
                            </div>
                        ) : (
                            <button
                                className={classes.enableButton}
                                onClick={onSubmit}
                            >Guardar</button>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
}